module.exports = __webpack_public_path__ + "static/afc70b78-708a-4046-bc35-c7da767bc963-ea5d844413c3840c7c3148c1694a7fc4.webp";